'use client'

import shipperCategoryService from '@/_service/shipper-category.service'
import { isUuid, resolveShipperCategoryId } from '@/_lib/filter-slugs'
import type { IShipper } from '@/_types'
import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'
import { useQueryState } from 'nuqs'
import BrandSkeleton from '../BrandSkeleton'
import ShipperCardLink from '../../../catalog/ShipperCardLink'
import { FEATURED_BRANDS } from '@/_utils/Constants'
import { Box } from '@chakra-ui/react'
import BrandTabs from '@/app/[locale]/(universal)/brand/_components/BrandTabs'

const ShippersByCategory = ({ shipperId }: { shipperId?: string | null }) => {
  const t = useTranslations()
  const [category] = useQueryState('category')

  const { data: categoriesData } = useQuery({
    queryKey: ['shipper-categories-list', shipperId],
    queryFn: () =>
      shipperCategoryService
        .getAll({ page: 1, limit: 30 }, shipperId ?? undefined)
        .then((res) => res.data),
    enabled: Boolean(category) && !isUuid(category),
  })

  const categories = categoriesData?.shipper_categories ?? []
  const categoryId =
    category && isUuid(category)
      ? category
      : resolveShipperCategoryId(category, categories)

  const canFetch =
    Boolean(category) &&
    (isUuid(category) || categories.length > 0) &&
    Boolean(categoryId)

  const { data, isLoading } = useQuery({
    queryKey: ['brands-category', categoryId],
    queryFn: () => shipperCategoryService.getById(categoryId),
    enabled: canFetch,
  })

  if (
    isLoading ||
    (Boolean(category) && !isUuid(category) && !categories.length)
  ) {
    return <BrandSkeleton />
  }
  if (!data?.data?.shipper_datas?.length) return null

  return (
    <Box mt={{ base: 6, lg: 0 }} px={{ base: 4, lg: 14 }}>
      <BrandTabs data={data.data.shipper_datas} />
    </Box>
  )

  // return (
  //   <section className='home-brands'>
  //     <div className='home-brands__grid'>
  //       {data.data.shipper_datas.map((shipper) => {
  //         const normalized: IShipper = {
  //           id: shipper.shipper_id,
  //           name: shipper.shipper_name,
  //           menu_image: shipper.shipper_menu_image,
  //         } as IShipper;

  //         // Hide the whole YokoPizza card
  //         if (
  //           normalized.id === FEATURED_BRANDS.yokopizza ||
  //           normalized.name?.replace(/\s/g, '').toLowerCase() === 'yokopizza'
  //         ) {
  //           return null;
  //         }

  //         return (
  //           <ShipperCardLink
  //             key={normalized.id}
  //             shipper={normalized}
  //             orderDeliveryLabel={t('order_delivery')}
  //             reserveTableLabel={t('reserve_table')}
  //           />
  //         );
  //       })}
  //     </div>
  //   </section>
  // );
}

export default ShippersByCategory
